import script from "./WorkshopDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkshopDashboard.vue?vue&type=script&setup=true&lang=js"

import "./WorkshopDashboard.vue?vue&type=style&index=0&id=0bdb4ff4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bdb4ff4"]])

export default __exports__